import request from "axios";

import types from "./types";

export function resetCurrentUser() {
  return {
    type: types.RESET_CURRENT_USER,
  };
}

export function logout() {
  return (dispatch) => {
    return request("/users/sign_out")
      .then(() => {
        dispatch(resetCurrentUser());
      })
      .catch((err) => {
        throw err;
      });
  };
}
